import React, { useState, useEffect } from "react";

import { supabase } from "../../supabaseClient";
import { useTournamentAuth } from "../../utils/authorization";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import CreateSquad from "../../components/createSquad/CreateSquad";
import SquadList from "../../components/SquadList/SquadList";
import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";

export default function Squads() {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();
  const [showForm, setShowForm] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger refresh
  const [tournamentData, setTournamentData] = useState({});

  // Check tournament authorization
  const { canManage } = useTournamentAuth(tournamentId);

  const handleSquadCreated = () => {
    setShowForm(false); // Collapse the form
    setRefreshKey((prevKey) => prevKey + 1); // Update refresh key to trigger refresh
  };

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: `/tournaments` },
    { label: `${tournamentData.name}`, path: tournamentPath(tournamentSlug) },
    { label: "Squads" },
  ];

  useEffect(() => {
    const fetchTournamentName = async () => {
      const { data, error } = await supabase
        .from("tournaments")
        .select("*")
        .eq("id", tournamentId)
        .single(); // Fetch a single row

      if (error) {
        console.error("Error fetching tournament data:", error);
      } else {
        setTournamentData(data);
      }
    };

    fetchTournamentName();
  }, [tournamentId]);

  return (
    <>
      <TournamentSubpageHead page="squads" />
      <div className="flex justify-center mb-4">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="card-board overflow-hidden mb-6">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            Squads
          </h1>
          <p className="text-sm text-brand-mist mt-1">
            Squad times and houses for this tournament.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        {canManage && !showForm && (
          <button
            onClick={() => setShowForm(true)}
            className="mt-4 bg-brand-charcoal text-white p-2 rounded"
          >
            Add Squad
          </button>
        )}
        {showForm && (
          <CreateSquad
            tournamentID={tournamentId}
            onSquadCreated={handleSquadCreated}
            onCancel={() => setShowForm(false)}
          />
        )}
        <SquadList tournamentID={tournamentId} key={refreshKey} />
      </div>
    </>
  );
}
